var exports = {
  "M": "FormSurface.module__surface___c1BHOE",
};

module.exports = exports;
